<template>
  <div class="container h-100">
		<div class="d-flex justify-content-center h-100">
			<div class="user_card">
				<div class="d-flex justify-content-center">
					<div class="brand_logo_container">
						<img src="img/icons/android-icon-192x192.png" width="100" class="brand_logo" alt="Logo">
					</div>
				</div>
                <base-alert v-show="form_has_error" type="info">
                    <span>{{error_message}}</span>
                </base-alert>
				<div class="d-flex justify-content-center form_container">
					<form v-on:submit.prevent="onSubmit">
						<div class="mb-3">
							<input type="email" name="" v-model="email" class="form-control input_user" value="" placeholder="email" required>
						</div>
						<div class="mb-2">
							<input type="password" name="" v-model="password" class="form-control input_pass" value="" placeholder="password" required>
						</div>
                        <div class="input-group mb-2">
                            <button type="submit" style="margin-top: 20px" name="button" class="btn login_btn" :disabled="isLoading" :class="{ 'loading' : isLoading}">
                                <span>Login</span>
                            </button>
                        </div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import axios from 'axios'
import { BaseAlert } from '@/components';
export default {
    components: {
      BaseAlert
    },
    data: () => ({
        email : '',
        password : '',
        type: ["", "info", "success", "warning", "danger"],
        form_has_error : false,
        error_message : '',
        isLoading : false,
    }),
    methods: {
        onSubmit () {
            if(!(this.email && this.password)){
                console.log('Fill all the details')
                return
            }
            this.isLoading = true
            axios.post('/login', {
                email: this.email,
                password: this.password
            })
            .then((response)=>{
                this.isLoading = false
                localStorage.setItem('token', response.data.token)
                axios.defaults.headers.common['Authorization '] = `Bearer ${response.data.token}`
                this.$router.replace({path: '/', force: true}).then(() => { this.$router.go() })
            })
            .catch((error)=>{
                console.log("🚀 ~ file: Login.vue:67 ~ onSubmit ~ error", error)
                this.isLoading = false
                this.error_message = error.response.data.message
                this.form_has_error = true
            });
        }
    },
};
</script>

<style scoped>
.user_card {
    height: 380px;
    width: 360px;
    margin-top: 100px;
    margin-bottom: auto;
    background: #27293D;
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 10px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    -moz-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-radius: 5px;

    }
    .brand_logo_container {
        position: absolute;
        height: 170px;
        width: 170px;
        top: -75px;
        border-radius: 50%;
        background: rgb(44, 45, 61);
        padding: 10px;
        text-align: center;
    }
    .brand_logo {
        height: 150px;
        width: 150px;
        border-radius: 50%;
        border: 2px solid white;
    }
    .form_container {
        margin-top: 0;
    }
    form{
        width : 80%;
    }
    .login_btn {
        width: 100%;
        color: white !important;
    }
    .login_btn:focus {
        box-shadow: none !important;
        outline: 0px !important;
    }
    .login_container {
        padding: 0 2rem;
    }
    .input-group-text {
        background: #c0392b !important;
        color: white !important;
        border: 0 !important;
        border-radius: 0.25rem 0 0 0.25rem !important;
    }
    .input_user,
    .input_pass:focus {
        box-shadow: none !important;
        outline: 0px !important;
    }
    .btn.loading {
        background-color: #CCC;
        padding-right: 40px;
    }
    .btn.loading:after {
        content: "";
        position: absolute;
        border-radius: 100%;
        right: 6px;
        top: 50%;
        width: 0px;
        height: 0px;
        margin-top: -2px;
        border: 2px solid rgba(255,255,255,0.5);
        border-left-color: #FFF;
        border-top-color: #FFF;
        animation: spin .6s infinite linear, grow .3s forwards ease-out;
    }
    @keyframes spin {
        to {
            transform: rotate(359deg);
        }
    }
    @keyframes grow {
        to {
            width: 14px;
            height: 14px;
            margin-top: -8px;
            right: 13px;
        }
    }
</style>
